<template>
  <div :class="$style.portrait">
    <div :class="$style.header">
      <span>{{ title }}</span>
      <img :src="`${$cdnLink}/suspend/tongyong/guanbi.png`" alt @click="close" />
    </div>
    <ul :class="$style.menuList" v-if="menu_list.length">
      <li v-for="menu in menu_list" :key="menu.menu_id">
        <div :class="$style.cell" @click="setActiveMenu(menu)">
          <span :class="menu.hint ? $style.hint : ''">{{ menu.name }}</span>
          <i :class="`iconfont yw-xiangyou ${activeShowId === menu.menu_id ? $style.iconActive : ''}`"></i>
        </div>
        <ul :class="$style.articleList" v-if="activeShowId === menu.menu_id">
          <li v-for="article in menu.article_list" :key="article.article_id" @click="showArticle(article)">
            <span :class="article.hint ? $style.hint : ''">{{ article.name }}</span>
          </li>
          <li v-if="active_menu.jump_mode != 0" :class="$style.more" @click="readMore">
            <span>了解更多</span>
            <i class="iconfont yw-xiangyou"></i>
          </li>
          <div v-if="(activeShowId === menu.menu_id) && (!menu.article_list ||!menu.article_list.length)" :class="$style.articleEmpty">
            <img :src="`${$cdnLink}/suspend/qingbao/empty.png`" alt="" />
            <p>
              快去<span>【{{ account_name }}】</span>获取更多信息吧
            </p>
            <p>公众号账号：{{ account_id }}</p>
            <Button class="btn" :data-clipboard-text="account_id" @click="buryReport">一键复制打开微信领取</Button>
          </div>
        </ul>
      </li>
    </ul>
    <div v-else :class="$style.articleEmpty">
      <img :src="`${$cdnLink}/suspend/qingbao/empty.png`" alt="" />
      <p>
        快去<span>【{{ account_name }}】</span>获取更多信息吧
      </p>
      <p>公众号账号：{{ account_id }}</p>
      <Button class="btn" :data-clipboard-text="account_id" @click="buryReport">一键复制打开微信领取</Button>
    </div>
    <Popup v-if="popupVisible" :type="tabType" :account="account_name" :accountId="account_id" text="获取更多攻略资讯" @close="popupVisible = false"></Popup>
    <BoxDownLoad v-if="boxDownLoadShow" @close="boxDownLoadShow=false" type="wx"></BoxDownLoad>
  </div>
</template>

<script>
import Popup from '../common/Popup.vue';
import { mapState } from 'vuex';
import { Button } from 'vant';
import Clipboard from 'clipboard';
import { gameOpenDownloads } from '@/bridge/AppJsBridge';
import { buryReport } from '@/libs/business/account'
import BoxDownLoad from '../common/boxDownload.vue';
import { generJumpLink } from '@/libs/business/box'

export default {
  name: '',
  props: ['tabType'],
  data() {
    return {
      active_menu: {},
      article_list: [],
      is_empty: true, // menu为空时候
      popupVisible: false,
      activeShowId: undefined,
      boxDownLoadShow: false,
    };
  },
  async mounted() {
    this.copyInit();
    this.$nextTick(() => {
      this._initActiveArticle();
    });
  },
  components: {
    Popup,
    Button,
    BoxDownLoad
  },
  computed: {
    ...mapState({
      account_name: (state) => state.suspend.account_name,
      account_id: (state) => state.suspend.account_id,
      raidersList: (state) => state.suspend.raidersList,
      messagesList: (state) => state.suspend.messagesList,
    }),
    menu_list() {
      return this.tabType === 'messages' ? this.messagesList : this.raidersList;
    },
    title() {
      return this.tabType === 'messages' ? '情报' : '攻略';
    },
  },
  methods: {
    buryReport() {
      buryReport(this.tabType === 'messages' ? 'MESSAGE_CLICK_COPY' : 'STRATEGY_CLICK_COPY')
    },
    copyInit() {
      this.clipboard = new Clipboard('.btn');
      this.clipboard.on('success', () => {
        this.$toast({
          message: '复制成功',
          position: 'bottom'
        });
        gameOpenDownloads({
          gameUrl: 'weixin://'
        })
      });
    },
    close() {
      this.$emit('close');
    },
    // 初始化显示的文章
    async _initActiveArticle() {
      this.active_menu = this.menu_list[0];
      if (this.active_menu) {
        this.article_list = this.active_menu.article_list || [];
      }
    },
    async setActiveMenu(menu) {
      this.activeShowId = menu.menu_id === this.activeShowId ? '' : menu.menu_id;
      this.active_menu = menu;
      this.article_list = this.active_menu.article_list || [];
      // 分类下没有文章 清除红点
      if (!this.article_list || !this.article_list.length) {
        this.$store.commit('suspend/SET_MESSAGES_CACHE', { menu_id: this.active_menu.menu_id, article_id: ''});
      }
    },
    showArticle(article) {
      this.$store.commit('suspend/CHANGE_STATE', {
        sideBarVisible: false,
        portraitArticleVisible: true,
        active_article: article,
        active_menu: this.active_menu,
        active_menu_type: this.tabType
      });
      this.setCache(article);
    },
    setCache(article) {
      if (this.tabType !== 'messages') return;
      this.$store.commit('suspend/SET_MESSAGES_CACHE', { menu_id: this.active_menu.menu_id, article_id: article.article_id });
    },
    async readMore() {
      if (this.active_menu.jump_mode == 1) {
        this.popupVisible = true
      }
      if (this.active_menu.jump_mode == 3) {
        const gameUrl = await generJumpLink()
        gameOpenDownloads({
          gameUrl: gameUrl.wxBoxForumUrl
        })
        this.boxDownLoadShow = true;
      }
    }
  },
  beforeDestroy() {
    this.clipboard && this.clipboard.destroy();
  },
};
</script>

<style lang="scss" module>
@import '../common.scss';

.portrait {
  @include common-h5-wrap();
  background: #f9eff2;
  .header {
    background-color: #ffffff;
    border: none;
    margin: 0;
    width: 100%;
    > img {
      position: absolute;
      top: 0;
      right: 10px;
    }
  }
  .menuList {
    height: 350px;
    padding-bottom: 50px;
    overflow: auto;
    > li {
      .cell {
        height: 34px;
        background: #ffffff;
        margin-top: 6px;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        align-items: center;
        padding: 0 26px;
        color: #7a7979;
        > span {
          position: relative;
          &.hint {
            &:before {
              position: absolute;
              content: ' ';
              top: -2px;
              right: -8px;
              width: 3px;
              height: 3px;
              border-radius: 50%;
              background: #da3c22;
            }
          }
        }
        .iconActive {
          transform: rotate(90deg);
        }
        :global {
          .yw-xiangyou {
            color: #c5c5c5;
          }
        }
      }
    }
    .articleList {
      > li {
        background: #fdf0e7;
        height: 34px;
        margin-bottom: 1px;
        font-size: 12px;
        color: #959595;
        line-height: 34px;
        padding-left: 26px;
        > span {
          position: relative;
          &.hint {
            &:before {
              position: absolute;
              content: ' ';
              top: -2px;
              right: -8px;
              width: 3px;
              height: 3px;
              border-radius: 50%;
              background: #da3c22;
            }
          }
        }
      }
      .more {
        color: #ff5b58;
        font-size: 12px;
        text-align: right;
        padding-right: 24px;
        :global {
          .yw-xiangyou {
            color: #ff5b58;
            font-size: 12px;
          }
        }
      }
    }
  }
  .articleEmpty {
    font-size: 12px;
    text-align: center;
    color: #7A7979;
    padding-top: 60px;
    > img {
      display: inline-block;
      width: 90px;
      margin-bottom: 15px;
    }
    > p {
      color: #7a7979;
      margin-bottom: 5px;
      > span {
        color: #ff5955;
      }
    }
    > button {
      width: 146px;
      height: 24px;
      background: #ff5b58;
      border-radius: 12px;
      color: #ffffff;
      border: none;
      font-size: 11px;
    }
  }
}
</style>
